module.exports = __webpack_public_path__ + "resources/img/img_i_onenet2_m.c00ba3a276948b510e6568559ff7ab2a.png";